
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-information-agreement-freelance',
  templateUrl: './information-agreement-freelance-en.component.html',
  styleUrls: ['./information-agreement-freelance-en.component.scss']
})
export class InformationAgreementFreelanceEnComponent implements OnInit {
  @Output()
  accept = new EventEmitter();

  accepted = false;
  medicalConsultantAccepted = false;

  constructor() { }

  ngOnInit(): void {
  }

  public allAccepted = () => {
    return this.accepted && this.medicalConsultantAccepted;
  }
  public onAccept = () => {
    this.accept.emit();
  }
}
